import { Stack, ViewHeader, ViewItemField } from '@fukuri-admins/ui/common';

type Props = {
  /** 利用者氏名 */
  fullName: string;
  /** メールアドレス（未設定の場合は '-'） */
  email: string;
  /** 利用企業名 */
  clientName: string;
  /** 利用開始日（表示整形済み。billable_from が null の場合は '-'） */
  billableFromLabel: string;
  /** 作成日時（表示整形済み） */
  createdAtLabel: string;
  /** 更新日時（表示整形済み） */
  updatedAtLabel: string;
  /** 編集リンク */
  editLink: string;
  /**
   * アクティベーションコード・電話番号を表示するか
   * PartnerFeatureFlag の activation_code が有効な場合に true
   */
  isActivationCodeEnabled: boolean;
  /** アクティベーションコード（未設定の場合は '-'） */
  activationCode: string;
  /** 電話番号（未設定の場合は '-'） */
  phoneNumber: string;
  /**
   * カスタムフィールドの表示アイテム一覧（空配列の場合はセクション非表示）
   */
  customFields: {
    /** 表示ラベル */
    label: string;
    /** 整形済みの表示値 */
    value: string;
  }[];
};

/**
 * 利用者詳細プロフィール Presentation
 */
export const UserDetailProfilePresentation: React.FC<Props> = ({
  fullName,
  email,
  clientName,
  billableFromLabel,
  createdAtLabel,
  updatedAtLabel,
  editLink,
  isActivationCodeEnabled,
  activationCode,
  phoneNumber,
  customFields,
}) => (
  <Stack direction='column' gap={24}>
    <ViewHeader title={fullName} editLink={editLink} />
    <Stack direction='column' gap={24}>
      <ViewItemField label='利用企業名' direction='row' value={clientName} />
      <ViewItemField label='メールアドレス' direction='row' value={email} />
      {isActivationCodeEnabled && (
        <ViewItemField label='利用開始コード' direction='row' value={activationCode} />
      )}
      {isActivationCodeEnabled && (
        <ViewItemField label='電話番号' direction='row' value={phoneNumber} />
      )}
      {customFields.length > 0 &&
        customFields.map(field => (
          <ViewItemField
            key={field.label}
            label={field.label}
            direction='row'
            value={field.value}
          />
        ))}
      <ViewItemField label='利用開始日' direction='row' value={billableFromLabel} />
      <ViewItemField label='作成日時' direction='row' value={createdAtLabel} />
      <ViewItemField label='更新日時' direction='row' value={updatedAtLabel} />
    </Stack>
  </Stack>
);
